export default __webpack_public_path__ + "367d4ce.png";